module.exports = __webpack_public_path__ + "img/dagens-industri.8a5b07c.png";